export default "__VITE_ASSET__99f64381__"